import {tgxApi} from "../../../app/tgxApi";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {
    getAuthorizationHeader, getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const jurisdictionApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchAllJurisdiction: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                return {
                    url: `/ajax/jurisdictions`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body:data
                };
            },
            providesTags: ['jurisdictions'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getJurisdictionById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-jurisdiction-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['jurisdictionById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getJurisdictionsByCollectorId: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-jurisdictions-by-collector-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['jurisdictionByCollectorId'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createJurisdiction: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/jurisdiction`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['jurisdictions'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Jurisdiction")
            },
        }),
        updateJurisdiction: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update/jurisdiction/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['jurisdiction', 'jurisdictionById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Jurisdiction")
            },
        }),
        updateJurisdictionsCollector: build.mutation({
            query: ({jurisdictionIds, collectorId,deleteCollectorId}) => {
                let paramData=serialize({jurisdictionIds: jurisdictionIds, collectorId: collectorId,deleteCollectorId:deleteCollectorId})
                return {
                    url: `/ajax/update-jurisdictions-collector?${paramData}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['jurisdiction', 'jurisdictionByCollectorId','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Jurisdiction By collector Id")
            },
        }),
        exportJurisdictionData: build.query({
            query: (query) => {
                return {
                    url: `/export/jurisdictions`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("jurisdiction"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        deleteJurisdiction: build.mutation({
            query: (id) => {

                return {
                    url: `/ajax/delete-jurisdiction-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['jurisdictionById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Jurisdiction");
            },
        }),
        getJurisdictionByTaxList: build.query({
            query: (jurisdictionIds) => {
                // Serialize the data to query parameters
                let paramData = serialize({jurisdictionIds: jurisdictionIds})
                return {
                    url: `/ajax/get-jurisdiction-tax-rate?jurisdictionIds=${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['jurisdictionTaxList'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Tax Rate")
            },
        }),
        getJurisdictionsNextMonthDues: build.query({
            query: ({hasSuite, jurisdictions}) => {
                // Serialize the data to query parameters
                return {
                    url: `/ajax/get-jurisdiction-next-month-due?hasSuite=${hasSuite}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: jurisdictions,
                };
            },
            providesTags: ['jurisdictionNextMonthDues'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});

export const {
    useSearchAllJurisdictionQuery,
    useCreateJurisdictionMutation,
    useGetJurisdictionByIdQuery,
    useUpdateJurisdictionMutation,
    useLazyGetJurisdictionByTaxListQuery,
    useLazyGetJurisdictionsNextMonthDuesQuery,
    useGetJurisdictionsByCollectorIdQuery,
    useUpdateJurisdictionsCollectorMutation,
    useDeleteJurisdictionMutation,
    useLazyExportJurisdictionDataQuery
}=jurisdictionApi
